var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.516712 3.51675L4.83338 7.83342C5.48338 8.48342 6.53338 8.48342 7.18338 7.83342L11.5 3.51675C12.55 2.46675 11.8 0.666748 10.3167 0.666748H1.68338C0.200045 0.666748 -0.533288 2.46675 0.516712 3.51675Z","fill":"black"}));
}

Icon.defaultProps = {"width":"12","height":"9","viewBox":"0 0 12 9","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
